import ComposerDebug from '@intercom/embercom-composer/components/composer-debug';
export default ComposerDebug;
